export type SocialNetwork = 'facebook' | 'twitter' | 'linkedin' | 'reddit';
const SOCIAL_NETWORK_TO_LINK_MAP: Record<SocialNetwork, string> = {
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  twitter: 'https://twitter.com/share',
  linkedin: 'https://linkedin.com/shareArticle',
  reddit: 'https://reddit.com/submit',
};

export default function createLinkFor(
  name: SocialNetwork,
  params: Record<string, string | number | undefined | null>,
) {
  return `${SOCIAL_NETWORK_TO_LINK_MAP[name]}?${Object.entries(params)
    .filter(([, value]) => value)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )
    .join('&')}`;
}
